import { useDispatch, useSelector } from "react-redux";
import {
  downloadMarksTemplate,
  getStudentDetails,
  getStudentSubjectMarks,
  resetUrl,
  setHistorySearch,
  UpdateSubjectMarks,
  uploadExamMarks,
} from "../store/examAndGrade";

export function useExamAndGradeStore() {
  const dispatch = useDispatch();

  const examAndGradeData = useSelector((state) => state.examAndGrade.data);
  const fileUrl = useSelector((state) => state.examAndGrade.fileUrl);
  const studentMarksData = useSelector(
    (state) => state.examAndGrade?.studentMarksData
  );
  const studentDetails = useSelector(
    (state) => state.examAndGrade.studentDetails
  );
  const recentFiles = useSelector((state) => state.examAndGrade.recentFiles);
  const historySearch = useSelector((state) => state.examAndGrade.historySearch);
  const loading = useSelector((state) => state.examAndGrade?.loading);

  const uploadExamMarksAction = (params) => dispatch(uploadExamMarks(params));
  const setHistorySearchAction = (params) => dispatch(setHistorySearch(params));
  const downloadMarksTemplateAction = (params) =>
    dispatch(downloadMarksTemplate(params));
  const resetUrlAction = () => dispatch(resetUrl());
  const getStudentSubjectMarksAction = (params) =>
    dispatch(getStudentSubjectMarks(params));
  const getStudentDetailsAction = (params) =>
    dispatch(getStudentDetails(params));
  const UpdateSubjectMarksAction = (params) =>
    dispatch(UpdateSubjectMarks(params));

  return {
    fileUrl,
    loading,
    examAndGradeData,
    uploadExamMarksAction,
    downloadMarksTemplateAction,
    resetUrlAction,
    getStudentSubjectMarksAction,
    getStudentDetailsAction,
    UpdateSubjectMarksAction,
    setHistorySearchAction,
    historySearch,
    studentMarksData,
    studentDetails,
    recentFiles,
  };
}
